import { useContext } from './useFormContext';

const targetsAndCurrenciesMapper: Record<string, Record<string, string>> = {
  webmoney_withdrawal: {
    USD: 'Z',
    RUB: 'R',
    EUR: 'E',
    mBTC: 'X',
    WMT: 'T',
  },
  perfect_money_withdrawal: {
    USD: 'U',
    EUR: 'E',
  },
};

const useTargets = (vendorCurrency: string): string[] => {
  const { extra, paysystem } = useContext();
  let modelTargets = extra.targets || [];
  if (targetsAndCurrenciesMapper[paysystem]) {
    modelTargets = modelTargets.filter((t) => t.startsWith(targetsAndCurrenciesMapper[paysystem][vendorCurrency]));
  }
  return modelTargets;
};

export default useTargets;
